import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '50%',
    width: 560
  }
}));

const NotFound = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
            <Typography variant="h1">
              404: Not Found
            </Typography>
            <Typography variant="subtitle2">
              It looks like our wires are crossed. It's not fatal.
              But we can't find and connect you to the page you're looking for.
            </Typography>
            <img
              alt="Under development"
              className={classes.image}
              src="/images/page_not_found.png"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
